import { render, staticRenderFns } from "./organization-user-modal.vue?vue&type=template&id=1d243f49&scoped=true"
import script from "./organization-user-modal.vue?vue&type=script&lang=js"
export * from "./organization-user-modal.vue?vue&type=script&lang=js"
import style0 from "./organization-user-modal.vue?vue&type=style&index=0&id=1d243f49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d243f49",
  null
  
)

export default component.exports